module.exports = __webpack_public_path__ + "static/media/6_School of the animals_IN.e0c3ca3c.txt";